import React from 'react';
import { Image, View } from 'react-native';
import { img_arrow_right_button } from '../../../../utils/ImagesManagementUtils';
import { Android } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const ArrowInsideBigSquareBtn = ({
  tintColor,
  backgroundColor,
  simPlatform,
  isShapeSquare,
}) => {
  const myStyles = {
    buttonNext: {
      width: '30%',
      height: 35,
      borderRadius: isShapeSquare ? 3 : 18,
      marginLeft: '40%',
      marginTop: simPlatform === Android ? '100%' : '90%',
      position: 'absolute',
      backgroundColor,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },
    arrow: {
      width: 20,
      height: 20,
      tintColor,
    },
  };
  return (
    <View style={myStyles.buttonNext}>
      <Image
        fadeDuration={0}
        style={myStyles.arrow}
        source={img_arrow_right_button}
      />
    </View>
  );
};
export default ArrowInsideBigSquareBtn;
